import {ConfirmationModalProps} from './types'
import ConfirmationModalView from './ConfirmationView'
import {NinchatDialogueUpdatedEvent} from 'api/types/events'
import {NinchatProperties} from 'api/types'
import React from 'react'
import {confirmationModal} from '../../../actions/modal'
import {deleteMessage} from '../../../api/action/deleteMessage'
import {navigation} from 'navigation'
import {toast} from '../../Toast'
import {updateDialogue} from 'api/action/updateDialogue'
import {updateQueue} from '../../../api/action/updateQueue'
import {updateRealm} from 'api/action/updateRealm'
import {updateUser} from '../../../api/action/updateUser'
import {useAppDispatch} from '../../../hooks'
import {useTranslation} from 'react-i18next'

const ConfirmationModal = (props: ConfirmationModalProps): React.ReactElement => {
    const {
        onConfirm,
        text,
        title,
    } = props

    const dispatch = useAppDispatch()

    const {t} = useTranslation()

    const closeModal = () => {
        dispatch(confirmationModal({show: false}))
    }

    const onCancel = () => {
        closeModal()
    }

    const onConfirmHandler = () => {
        switch (onConfirm.action) {
            case 'closeQueue':
                dispatch(updateQueue({
                    queue_attrs: {closed: true},
                    queue_id: onConfirm.queueId,
                }))
                    .unwrap()
                    .then(
                        () => {
                            toast.success(t('Queue is now closed'))
                        },
                        () => {
                            toast.success(t('Error closing queue'))
                        },
                    )
                break
            case 'deleteMessage':
                dispatch(deleteMessage({
                    channel_id: onConfirm.chat.channel_id,
                    message_id: onConfirm.messageId,
                    user_id: onConfirm.chat.user_id,
                }))
                break
            case 'hideDialogue':
                dispatch(updateDialogue({
                    dialogue_status: 'hidden',
                    user_id: onConfirm.dialogueId as NinchatProperties.DialogueID,
                }))
                    .unwrap()
                    .then(
                        (result) => {
                            const {
                                dialogue_status, event,
                            } = result as unknown as NinchatDialogueUpdatedEvent

                            if (dialogue_status === 'hidden' && event === 'dialogue_updated') {
                                navigation.push('Home')
                            }
                        },
                    )
                break
            case 'openQueue':
                dispatch(updateQueue({
                    queue_attrs: {closed: false},
                    queue_id: onConfirm.queueId,
                }))
                    .unwrap()
                    .then(
                        () => {
                            toast.success(t('Queue is now open'))
                        },
                        () => {
                            toast.success(t('Error opening queue'))
                        },
                    )
                break
            case 'removeCannedMessage':
                dispatch(updateUser({user_settings: onConfirm.userSettings}))
                    .unwrap()
                    .then(
                        () => {
                            toast.success(t('Canned message removed'))
                        },
                        () => {
                            toast.success(t('Error removing canned message'))
                        },
                    )
                break
            case 'removeRealmCannedMessage':
                dispatch(updateRealm({
                    realm_id: onConfirm.realmId,
                    realm_settings: onConfirm.realmSettings,
                }))
                    .unwrap()
                    .then(
                        () => {
                            toast.success(t('Canned message removed'))
                        },
                        () => {
                            toast.success(t('Error removing canned message'))
                        },
                    )
                break
            default:
        }
        closeModal()
    }

    return (
        <ConfirmationModalView
            onCancel={onCancel}
            onConfirm={onConfirmHandler}
            text={text}
            title={title}
        />
    )
}

export default ConfirmationModal
